import React, { useEffect, useRef, useState } from "react";
import { Logo, LogoImg, MenuList, MenuSider, Title } from "./AsidMenu.style";

import { MenuProps } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MenuItem } from "@/assets/interface/asidMenu";
import { useAppDispatch, useAppSelector } from "@/store";
import { changeOpenKey, changeSelectMenuKey } from "@/store/modules/globalConstans.slice";
import { isEmpty } from "lodash";
import { getAllAuthoritiesAction } from "@/store/action/loginAction";

interface IAsidMenu {
  click: MenuProps["onClick"];
  selectTab: string;
  defaultSelectTab: string[];
}

export let items: any

/**
 * 菜单栏组件
 * @param {*} click 菜单栏点击事件
 * @param {*} seslectTab 当前菜单栏选中的项
 */
export default function AsidMenu(props: IAsidMenu) {
  const { click, selectTab, defaultSelectTab } = props;
  // 跳转方法
  const navigator = useNavigate();
  const location = useLocation();
  let { t, i18n: i18nInstance } = useTranslation(); // 加载语言模块
  const dispatch = useAppDispatch();
  const [authoritiesItemList, setAuthoritiesItemList] = useState<MenuItem[]>(
    []
  );
  const [superAdmin, setSuperAdmin] = useState<boolean>(false);
  // 菜单栏展开关闭 collapsed
  // 菜单项打开关闭 openKey
  const { collapsed, openKey, selectMenuKey } = useAppSelector(
    (state) => state.globalConstans
  );

  // 展开可选性方法
  const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey = keys.find((key) => openKey?.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey!) !== -1) {
      dispatch(changeOpenKey(keys));
    } else {
      dispatch(changeOpenKey(latestOpenKey ? [latestOpenKey] : []));
    }
  };

  // 可展开项集合
  const rootSubmenuKeys = [
    "/userManagement",
    "/proxyCenter",
    "/systemBilling",
    "/roles",
    "/systemSetting",
    "/rechargeManagement",
    "/withdrawal",
    "/helpCenter",
    "/game",
  ];

  // 获取菜单项
  const getItem = (
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    onClick?: () => void,
    hidden?: boolean,
    type?: "group"
  ): MenuItem => {
    return {
      key,
      icon,
      children,
      label,
      onClick,
      hidden,
      type,
    } as MenuItem;
  };

  const renderIcon = (tabUrl: string, src1: string, src2: string) => {
    return <img src={`${selectTab.includes(tabUrl) ? src1 : src2}`} />;
  };

  // 菜单项
  items = [
    getItem(
      `${t("Data Center")}`,
      "/admin/dataCenter",
      renderIcon(
        "/admin/dataCenter",
        `${require("@/assets/img/icon/utab8.png")}`,
        `${require("@/assets/img/icon/tab8.png")}`
      ),
      undefined,
      () => {
        navigator("/admin/dataCenter");
        dispatch(changeOpenKey(['/admin/dataCenter']));
      },
      undefined
    ),
    getItem(
      `${t("User management")}`,
      "/userManagement",
      renderIcon(
        "/userManagement",
        `${require("@/assets/img/icon/utab5.png")}`,
        `${require("@/assets/img/icon/tab5.png")}`
      ),
      [
        getItem(`${t("User List")}`,
          "/admin/user",
          undefined,
          undefined,
          () => {
            navigator("/userManagement/userList");
          }),
        getItem(
          `${t("Draw Record")}`,
          "/admin/group",
          undefined,
          undefined,
          () => {
            navigator("/userManagement/groupManagement");
          }
        ),
        getItem(`${t("Robot List")}`, "/admin/post", undefined, undefined, () => {
          navigator("/userManagement/circleOfFriends");
        }),
        // getItem(
        //   `${t("用户举报")}`,
        //   "/admin/report",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/userManagement/UserReporting");
        //   }
        // ),
      ]
    ),
    getItem(
      `${t("Lottery management")}`,
      "/admin/bill",
      renderIcon(
        "/systemBilling",
        `${require("@/assets/img/icon/utab1.png")}`,
        `${require("@/assets/img/icon/tab1.png")}`
      ),
      [
        getItem(
          `${t("Current drawing period")}`,
          "/admin/charge/goldCharges",
          undefined,
          undefined,
          () => {
            navigator("/systemBilling/cashSaveDetails");
          }
        ),
        getItem(
          `${t("Create drawing period")}`,
          "/admin/bill/goldCoinDetail/goldCoinDetails",
          undefined,
          undefined,
          () => {
            navigator("/systemBilling/cashAccountDetails");
          }
        ),
        getItem(
          `${t("Prize hub")}`,
          "/admin/bill/goldCoinDetail/danzhuPayDetails",
          undefined,
          undefined,
          () => {
            navigator("/systemBilling/cashToMarbles");
          }
        ),
        getItem(
          `${t("history drawing period")}`,
          "/admin/bill/silverCoinDetail/danzhuRecoveryDetails",
          undefined,
          undefined,
          () => {
            navigator("/systemBilling/marblesRecovery");
          }
        ),
        getItem(
          `${t("Winging reacord")}`,
          "/admin/bill/silverCoinDetail/silverCoinDetails",
          undefined,
          undefined,
          () => {
            navigator("/systemBilling/giftAccountDetails");
          }
        ),

      ]
    ),
    // getItem(
    //     `${t("商戶管理")}`,
    //     "/admin/system/conf/merchant",
    //     renderIcon(
    //         "/merchantManagement",
    //         `${require("@/assets/img/icon/utab2.png")}`,
    //         `${require("@/assets/img/icon/tab2.png")}`
    //     ),
    //     [
    //       getItem(
    //           `${t("商戶列表")}`,
    //           "/admin/biz/",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/merchantManagement/merchantList");
    //           }
    //       ),
    //       getItem(
    //           `${t("商戶商品列表")}`,
    //           "/admin/bizGoods/",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/merchantManagement/merchantProductList");
    //           }
    //       ),
    //       getItem(
    //           `${t("商戶賬目明細")}`,
    //           "/admin/bizTrade/",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/merchantManagement/merchandiseAccountDetail");
    //           }
    //       ),

    //       getItem(
    //           `${t("用戶兌換記錄")}`,
    //           "/admin/bizOrder/",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/merchantManagement/subscriberExchangeRecord");
    //           }
    //       ),
    //       getItem(
    //           `${t("申请结算列表")}`,
    //           "/admin/bizSettle/",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/merchantManagement/applicationForSettlementList");
    //           }
    //       ),

    //       getItem(
    //           `${t("結算記錄")}`,
    //           "/a/merchant/settlementRecorddmin",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/merchantManagement/settlementRecord");
    //           }
    //       ),
    //       getItem(
    //         `${t("營業執照審核")}`,
    //         "/admin/biz/permitAuditRecords",
    //         undefined,
    //         undefined,
    //         () => {
    //           navigator("/merchantManagement/businessLicenseReview");
    //         }
    //     ),
    //       getItem(
    //         `${t("業務員列表")}`,
    //         "/admin/bizSales",
    //         undefined,
    //         undefined,
    //         () => {
    //           navigator("/merchantManagement/salesperson");
    //         }
    //     ),
    //     getItem(
    //       `${t("商家輪播圖")}`,
    //       "/admin/bizAdList",
    //       undefined,
    //       undefined,
    //       () => {
    //         navigator("/merchantManagement/swiper");
    //       }
    //   ),
    //     ],
    // ),
    // getItem(
    //     `${t("二维码管理")}`,
    //     "/admin/qrCodeManage",
    //     renderIcon(
    //         "/qrCodeManager",
    //         `${require("@/assets/img/home/tab14.png")}`,
    //         `${require("@/assets/img/home/tab15.png")}`
    //     ),
    //     [
    //       getItem(
    //           `${t("二维码批次")}`,
    //           "/admin/silverQrCodeBatch",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/qrCodeManager/qrCodeBatch");
    //           }
    //       ),
    //       getItem(
    //           `${t("持码人列表")}`,
    //           "/admin/silverQrCodeOwner",
    //           undefined,
    //           undefined,
    //           () => {
    //             navigator("/qrCodeManager/qrCoderList");
    //           }
    //       ),
    //     ],
    // ),
    // getItem(
    //     `${t("在线客服")}`,
    //     "/admin/chat",
    //     renderIcon(
    //         "/onlineService",
    //         `${require("@/assets/img/home/tab14.png")}`,
    //         `${require("@/assets/img/home/tab15.png")}`
    //     ),
    //     undefined,
    //     () => {
    //       navigator("/onlineService");
    //       dispatch(changeOpenKey(['/admin/chat']));
    //     }
    // ),
    getItem(
      `${t("System Account")}`,
      "/admin/system/conf",
      renderIcon(
        "/systemSetting",
        `${require("@/assets/img/icon/utab.png")}`,
        `${require("@/assets/img/icon/tab.png")}`
      ),
      [
        // getItem(
        //   `${t("操作记录")}`,
        //   "/admin/operatingRecord",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemSetting/operationRecord");
        //   }
        // ),
        // getItem(
        //   `${t("版本管理")}`,
        //   "/admin/versionManagement",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemSetting/versionManagement");
        //   }
        // ),
        getItem(
          `${t("Role management")}`,
          "/admin/role/role",
          undefined,
          undefined,
          () => {
            navigator("/systemSetting/rolesList");
          }
        ),
        getItem(
          `${t("Account management")}`,
          "/admin/role/admin",
          undefined,
          undefined,
          () => {
            navigator("/systemSetting/adminList");
          }
        ),
        // getItem(
        //   `${t("相关地址配置")}`,
        //   "/admin/addressConfiguretion",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemSetting/addressConfiguretion");
        //   }
        // ),
        // getItem(
        //   `${t("轮播图管理")}`,
        //   "/admin/adLists",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemSetting/noticManagement");
        //   }
        // ),
        // getItem(
        //   `${t("活动管理")}`,
        //   "/admin/active",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemSetting/eventManagement");
        //   }
        // ),
        // getItem(
        //   `${t("充值选项配置")}`,
        //   "/admin/charge/conf/amountList",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemSetting/chargeOptions");
        //   }
        // ),
        // getItem(
        //   `${t("验证码查询")}`,
        //   "/admin/verifyCodes",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator("/systemBilling/verifyCodes");
        //   }
        // ),
        // getItem(
        //   '支付贈送積分配置',
        //   '/SystemSetting/integralConfig',
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator('/systemSetting/integralConfig')
        //   }
        // ),
        // getItem(
        //   '功能開關',
        //   "/admin/msgRecord",
        //   undefined,
        //   undefined,
        //   () => {
        //     navigator('/systemSetting/transferSwitch');
        //   }
        // )
        // getItem(
        //       `${t("礼金账目变动")}`,
        //       "/admin/bill/giftCoinDetail/giftCoinDetails",
        //       undefined,
        //       undefined,
        //       () => {
        //           navigator("/systemSetting/changeInTheGiftAccount");
        //       }
        //   ),
      ]
    ),
    // getItem(
    //   '消息推送中心',
    //   '/admin/msgRecord',
    //   renderIcon(
    //     "/admin/msgRecord",
    //     `${require("@/assets/img/icon/message_push_active.png")}`,
    //     `${require("@/assets/img/icon/message_push.png")}`
    //   ),
    //   undefined,
    //   () => {
    //     navigator('/messagePush/messagePush')
    //   },
    // )
  ];

  // 递归遍历
  const checkChildren = (children: any, authoritiesItem: any) => {
    const filteredChildren = children.filter((child: any) => {
      return !(
        child.key === authoritiesItem.urlPrefix && authoritiesItem.get === 0
      );
    });
    return filteredChildren.some((child: any) => {
      if (
        child.key === authoritiesItem.urlPrefix &&
        authoritiesItem.get === 1
      ) {
        return true;
      }
      if (child.children) {
        return checkChildren(child.children, authoritiesItem);
      }
      return false;
    });
  };

  const getAllAuthorities = () => {
    dispatch(getAllAuthoritiesAction(localStorage.getItem("user_uid"))).then(
      (res) => {
        if (isEmpty(res.payload.data)) {
          setSuperAdmin(true);
        } else {
          setSuperAdmin(false);
          const authoritiesList = res.payload.data;
          const newAuthoritiesList = items.filter((item: any) => {
            return authoritiesList.some((authoritiesItem: any) => {
              if (
                item.key === authoritiesItem.urlPrefix &&
                authoritiesItem.get === 1
              ) {
                return true;
              }
              if (item.children) {
                return checkChildren(item.children, authoritiesItem);
              }
              return false;
            });
          });
          setAuthoritiesItemList(newAuthoritiesList);
        }
      }
    );
  };

  useEffect(() => {
    getAllAuthorities();
  }, [i18nInstance.language]);

  return (
    <MenuSider trigger={null} collapsible collapsed={collapsed} width={255}>
      <Logo>
        <LogoImg />
        {/* <Title collapsed={collapsed}>{t("QTalk后台管理系统")}</Title> */}
      </Logo>
      <Title collapsed={collapsed}>{t("Welcome")}</Title>
      <MenuList
        style={{ background: "transparent" }}
        theme="dark"
        mode="inline"
        defaultSelectedKeys={selectMenuKey}
        // defaultSelectedKeys={defaultSelectTab}
        // items={items}
        items={superAdmin ? items : authoritiesItemList}
        onClick={(event: any,) => {
          const parentMenuItem = event.keyPath[1] || event.keyPath[0]
          dispatch(changeSelectMenuKey([event.key]))
          dispatch(changeOpenKey([parentMenuItem]))

          click(event)
        }}
        openKeys={openKey}
        onOpenChange={onOpenChange}
      />
    </MenuSider>
  );
}
